// extracted by mini-css-extract-plugin
module.exports = {"meals":"AvailableMeals_meals__MdBzz","meals-appear":"AvailableMeals_meals-appear__3rE9t"};